import { Injectable, Pipe, PipeTransform, inject } from '@angular/core';

import { Observable, map } from 'rxjs';

import { LanguageService } from '@fcom/ui-translate';
import { safeMap } from '@fcom/rx';

/**
 */
@Injectable()
@Pipe({
  name: 'finCountryName',
  pure: false,
  standalone: false,
})
export class CountryNamePipe implements PipeTransform {
  private languageService = inject(LanguageService);

  transform(key: string): Observable<string> {
    type CountryCode = { countryCode: string; name: string };
    return this.languageService.translate<CountryCode[]>('countryCodes').pipe(
      map((countries: CountryCode[]) =>
        countries.find((country) => {
          return country.countryCode === key.toUpperCase();
        })
      ),
      safeMap(({ name }) => name)
    );
  }
}
